var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { IDENTIFIER_BUTTON } from 'src/ui/components/button/constants';
import { Icons } from 'src/ui/components/Icons/Icons';
import { EButtonType } from 'src/ui/components/button/Button';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './TextButton.module.scss';
export var TextButton = function (props) {
    var _a;
    var _b = props.type, type = _b === void 0 ? EButtonType.NEUTRAL : _b, label = props.label, href = props.href, rel = props.rel, target = props.target, _c = props.icon, icon = _c === void 0 ? E_ICONS.ARROW_RIGHT : _c, classname = props.classname, identifier = props.identifier, onClick = props.onClick;
    var buttonClass = classNames(styles.textButton, (_a = {},
        _a[styles[type]] = !!type,
        _a[classname] = !!classname,
        _a));
    var handleOnClick = function (e) {
        e.stopPropagation();
        if (onClick) {
            onClick();
        }
    };
    var buttonIdentifier = identifier ? identifier : IDENTIFIER_BUTTON;
    if (href) {
        return (_jsxs("a", __assign({ "data-test": buttonIdentifier, href: href, rel: rel, target: target, className: buttonClass, onClick: handleOnClick }, { children: [_jsx("span", { children: label }), _jsx(Icons, { icon: icon })] })));
    }
    return (_jsxs("button", __assign({ "data-test": buttonIdentifier, className: buttonClass, onClick: handleOnClick }, { children: [_jsx("span", { children: label }), _jsx(Icons, { icon: icon })] })));
};
